<template>
    <div class="customer__form modal modal--default">
        <div class="modal__panel">
            <div class="modal__logo-wrapper">
                <div class="modal__logo"></div>
                <!-- <div class="modal__logo-title">Seguro Desk</div> -->
            </div>

            <div class="modal__main-icon modal__main-icon--private"></div>
            <div class="modal__close" @click="closeModal()"></div>

            <div class="form">
                <form class="add__form">
                    <transition name="fade" mode="out-in">
                        <Loading v-if="formLoading" />
                        <div v-else class="add__content">
                            <transition name="fade" mode="out-in">
                                <div class="details" key="0">

                                    <div class="form__row">
                                        <div class="form__field form__field--double">
                                            <VSelect :options="memberTypes" :reduce="(type) => type.id"
                                                placeholder="Type" label="value" v-model="customerDetails.type"
                                                class="select select--default" />
                                        </div>

                                        <div class="form__field form__field--double">
                                            <VSelect :options="languages" :reduce="(language) => language.id"
                                                :placeholder="$t('addPrivateCostumerModal.language')"
                                                label="name" v-model="customerDetails.language"
                                                class="select select--default"
                                                :class="{ 'select--error': languageHasError }" />
                                            <div class="form__error" v-if="languageHasError">
                                                {{ $t(`addPrivateCostumerModal.${"languageErrorMsg"}`) }}
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form__field" v-if="customerDetails.type == 1">
                                        <input type="text" class="input input--default" placeholder="Company *"
                                            v-model="customerDetails.company"
                                            :class="{ 'input--error': companyHasError }" />
                                        <div class="form__error" v-if="companyHasError">
                                            {{ $t(`addPrivateCostumerModal.${"firstNameErrorMsg"}`) }}
                                        </div>
                                    </div>

                                    <div v-else>
                                        <div class="form__field">
                                            <input type="text" class="input input--default"
                                                :placeholder="$t('addPrivateCostumerModal.firstName') + ' *'"
                                                v-model="customerDetails.firstName" :class="{
                                                    'input--error': firstNameHasError,
                                                }" />
                                            <div class="form__error" v-if="firstNameHasError">
                                                {{ $t(`addPrivateCostumerModal.${"firstNameErrorMsg"}`) }}
                                            </div>
                                        </div>

                                        <div class="form__field">
                                            <input type="text" class="input input--default"
                                                :placeholder="$t('addPrivateCostumerModal.lastName') + ' *'"
                                                v-model="customerDetails.lastName"
                                                :class="{ 'input--error': lastNameHasError }" />
                                            <div class="form__error" v-if="lastNameHasError">
                                                {{ $t(`addPrivateCostumerModal.${"lastNameErrorMsg"}`) }}
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form__row">
                                        <div class="form__field form__field--double">
                                            <input type="text" class="input input--default"
                                                :placeholder="$t('addPrivateCostumerModal.street')"
                                                v-model="customerAdresses[0].street" :class="{
                                                    'input--error': streetHasError,
                                                }" />
                                            <div class="form__error" v-if="streetHasError">
                                                {{ $t(`addPrivateCostumerModal.${"streetErrorMsg"}`) }}
                                            </div>
                                        </div>
                                        <div class="form__field">
                                            <input type="text" class="input input--default input--nr" placeholder="Nr."
                                                v-model="customerAdresses[0].number" />
                                        </div>
                                    </div>

                                    <div class="form__row">
                                        <div class="form__field form__field--double">
                                            <input type="text" class="input input--default" placeholder="PLZ"
                                                v-model="customerAdresses[0].zip"
                                                :class="{ 'input--error': zipHasError }" />

                                            <div class="form__error" v-if="zipHasError">
                                                {{ zipCodePlaceholder }}
                                            </div>
                                        </div>
                                        <div class="form__field form__field--double">
                                            <VSelect v-if="zipCodeData.length > 1" :options="zipCodeData"
                                                :reduce="(city) => city.city"
                                                :placeholder="$t('addPrivateCostumerModal.city')"
                                                label="city" v-model="customerAdresses[0].city"
                                                class="select select--default" :class="{
                                                    'select--error': cityHasError,
                                                }" />

                                            <div v-else-if="zipCodeData.length"
                                                class="input input--default input--readonly"
                                                :class="{ 'input--error': cityHasError }">
                                                {{ customerAdresses[0].city }}
                                            </div>

                                            <input v-else-if="!zipCodeData.length" type="text"
                                                class="input input--default"
                                                :placeholder="$t('addPrivateCostumerModal.city')"
                                                v-model="customerAdresses[0].city"
                                                :class="{ 'input--error': cityHasError }" />

                                            <div class="form__error" v-if="cityHasError">
                                                {{ $t(`addPrivateCostumerModal.${"cityErrorMsg"}`) }}
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form__field">
                                        <div class="form__input-wrapper" v-for="(email, index) in customerEmails"
                                            :key="index">
                                            <input type="text" class="input input--default" placeholder="E-mail *"
                                                @input="validateEmail($event, index)" :value="email.email" :class="{
                                                    'input--error': email.hasError,
                                                }" />
                                            <div class="form__add" v-if="index === 0 && email.email"
                                                @click="addInput('email')"></div>
                                            <div class="form__remove" v-else-if="index !== 0"
                                                @click="removeInput('email', email.id, index)"></div>
                                            <div class="form__error" v-if="email.hasError">
                                                {{ email.errorPlaceholder }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form__field form__field--prefix">
                                        <div class="form__row" v-for="(phone, index) in customerPhones" :key="index">

                                            <div class="form__input-wrapper">
                                                <input type="text" class="input input--default"
                                                    :placeholder="$t('addPrivateCostumerModal.phone') + ' *'"
                                                    @input="validatePhone($event, index)" :value="phone.phone" :class="{
                                                        'input--error': phone.hasError,
                                                    }" />
                                                <div class="form__add" v-if="index === 0 && phone.phone"
                                                    @click="addInput('phone')"></div>
                                                <div class="form__remove" v-else-if="index !== 0"
                                                    @click="removeInput('phone', phone.id, index)"></div>
                                                <div class="form__error" v-if="phone.hasError">
                                                    {{ phone.errorPlaceholder }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form__field">
                                        <VSelect :options="teams" :reduce="(team) => team.id"
                                            :placeholder="$t('addPrivateCostumerModal.teams')" label="name"
                                            v-model="customerDetails.teamId" class="select select--default"
                                            :class="{ 'select--error': teamHasError }" />
                                        <div class="form__error" v-if="teamHasError">
                                            {{ $t(`addPrivateCostumerModal.${"teamErrorMsg"}`) }}
                                        </div>
                                    </div>
                                </div>
                            </transition>
                        </div>
                    </transition>
                </form>
            </div>
            <div v-if="isRequesting" class="modal__button modal__button--submit button button--default button--loading">
            </div>


            <button v-else type="button" class="modal__button modal__button--submit button button--default"
                @click="createCustomer()">
                <span>{{ $t(`addPrivateCostumerModal.${"save"}`) }}</span>
            </button>
        </div>
    </div>
</template>

<script setup>
import { ref, reactive, computed, watch, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import Loading from '@/partials/Loading';
import statics from '@/statics';
import parseFieldErrors from '@/helpers/parseFieldErrors';

defineOptions({
  name: 'LeadCustomerModal',
});

const store = useStore();
const route = useRoute();
const router = useRouter();
const { t } = useI18n();

const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const formLoading = ref(false);
const isRequesting = ref(false);
const showTeams = ref(false);

const customerDetails = reactive({
  gender: '',
  titleId: '',
  firstName: '',
  lastName: '',
  language: '',
  teamId: '',
  type: 2,
  company: '',
});

const memberTypes = [
  { id: 1, value: 'Firma' },
  { id: 2, value: 'Privat' },
];

const customerAdresses = reactive([
  {
    street: '',
    number: '',
    city: '',
    zip: '',
  },
]);

const customerEmails = ref([
  {
    email: '',
    hasError: false,
    errorPlaceholder: '',
  },
]);

const customerPhones = ref([
  {
    prefix: '',
    phone: '',
    hasError: false,
    errorPlaceholder: '',
  },
]);

const firstNameHasError = ref(false);
const lastNameHasError = ref(false);
const companyHasError = ref(false);
const languageHasError = ref(false);
const teamHasError = ref(false);
const zipHasError = ref(false);
const cityHasError = ref(false);
const streetHasError = ref(false);
const zipCodePlaceholder = ref('');

const customerInitialTeam = ref(null);
const specificErrors = ref([]);
const customerEditId = ref(null);

// Vuex getters
const customerForms = computed(() => store.getters.customerForms);
const customer = computed(() => store.getters.customer);
const loggedUser = computed(() => store.getters.loggedUser);
const leadCustomerToEdit = computed(() => store.getters.leadCustomerToEdit);

const languages = computed(() => customerForms.value.languages);
const teams = computed(() => customerForms.value.teams);

const zipCodeData = computed({
  get() {
    return store.state.zipCodes.zipCodeData;
  },
  set(value) {
    store.commit('setZipCodeData', value);
  },
});

const zip = computed(() => customerAdresses[0].zip);

// Watchers
watch(() => customerDetails.teamId, (value) => {
  teamHasError.value = !value;
});

watch(() => customerDetails.firstName, (value) => {
  firstNameHasError.value = !value;
});

watch(() => customerDetails.lastName, (value) => {
  lastNameHasError.value = !value;
});

watch(() => customerDetails.language, (value) => {
  languageHasError.value = !value;
});

watch(() => customerDetails.company, (value) => {
  companyHasError.value = !value;
});

watch(() => zip.value, async (newZip) => {
  if (newZip) {
    zipHasError.value = false;
    zipCodePlaceholder.value = '';

    if (Number(newZip) >= 1000 && Number(newZip) <= 9999) {
      await loadCities(newZip);
    } else {
      zipCodeData.value = [];
      customerAdresses[0].city = '';
      zipHasError.value = true;
      zipCodePlaceholder.value = t(`addPrivateCostumerModal.${'invalidZip'}`);
    }
  }
});

watch(specificErrors, (errors) => {
  const errorKeys = errors.map((error) => error.errorKey);

  if (errorKeys.includes('email')) {
    errors.forEach((error) => {
      if (error.errorKey === 'email') {
        customerEmails.value[error.errorPos].errorPlaceholder = error.errorValue;
        customerEmails.value[error.errorPos].hasError = true;
      }
    });
  } else {
    customerEmails.value.forEach((email) => {
      email.errorPlaceholder = '';
      email.hasError = false;
    });
  }

  if (errorKeys.includes('phone')) {
    errors.forEach((error) => {
      if (error.errorKey === 'phone') {
        customerPhones.value[error.errorPos].errorPlaceholder = error.errorValue;
        customerPhones.value[error.errorPos].hasError = true;
      }
    });
  } else {
    customerPhones.value.forEach((phone) => {
      phone.errorPlaceholder = '';
      phone.hasError = false;
    });
  }

  if (errorKeys.includes('first_name')) {
    firstNameHasError.value = true;
  } else {
    firstNameHasError.value = false;
  }

  if (errorKeys.includes('last_name')) {
    lastNameHasError.value = true;
  } else {
    lastNameHasError.value = false;
  }
}, { deep: true });

// Methods
const closeModal = () => {
  store.commit('setLeadCustomerToEdit', null);
  store.commit('setShowCustomerLeadModal', false);
  zipCodeData.value = [];
};

const loadFieldsForEdit = (customerData) => {
  customerEditId.value = customerData.id;
  customerDetails.teamId = customerData.team ? customerData.team.id : '';

  customerInitialTeam.value = customerData.team ? customerData.team.id : '';
  customerDetails.type = customerData.member_type ? customerData.member_type.id : '';
  customerDetails.company = customerData.company_name || '';
  customerDetails.firstName = customerData.first_name || '';
  customerDetails.lastName = customerData.last_name || '';
  customerDetails.language = customerData.language.id || '';
  customerAdresses[0].id = customerData.customer_addresses.length
    ? customerData.customer_addresses[0].id
    : '';
  customerAdresses[0].street = customerData.customer_addresses.length
    ? customerData.customer_addresses[0].street
    : '';
  customerAdresses[0].zip = customerData.customer_addresses.length
    ? customerData.customer_addresses[0].zip
    : '';
  customerAdresses[0].number = customerData.customer_addresses.length
    ? customerData.customer_addresses[0].number
    : '';
  customerAdresses[0].city = customerData.customer_addresses.length
    ? customerData.customer_addresses[0].city
    : '';
  customerEmails.value = customerData.customer_emails.length
    ? customerData.customer_emails.map((email) => ({
        id: email.id,
        email: email.email,
        hasError: false,
        errorPlaceholder: '',
      }))
    : [
        {
          id: '',
          email: '',
          hasError: false,
          errorPlaceholder: '',
        },
      ];
  customerPhones.value = customerData.customer_phones.length
    ? customerData.customer_phones.map((phone) => ({
        id: phone.id,
        prefix: phone.prefix,
        phone: phone.phone,
        hasError: false,
        errorPlaceholder: '',
      }))
    : [
        {
          id: '',
          prefix: '',
          phone: '',
          hasError: '',
          errorPlaceholder: '',
          prefixHasError: '',
          prefixErrorPlaceholder: '',
        },
      ];
};

const validateCustomerDetails = () => {
  const { firstName, lastName, language, teamId, type, company } = customerDetails;
  const { zip: zipValue, city: cityValue } = customerAdresses[0];

  if (type == 2) {
    firstNameHasError.value = !firstName;
    lastNameHasError.value = !lastName;
    companyHasError.value = false;
  } else if (type == 1) {
    companyHasError.value = !company;
    firstNameHasError.value = false;
    lastNameHasError.value = false;
  }

  languageHasError.value = !language;
  teamHasError.value = !teamId;

  if (zipValue) {
    if (!(Number(zipValue) >= 1000 && Number(zipValue) <= 9999)) {
      zipHasError.value = true;
      zipCodePlaceholder.value = 'Invalid zip code';
    } else {
      zipHasError.value = false;
      zipCodePlaceholder.value = '';
    }

    cityHasError.value = !cityValue;
  } else {
    zipHasError.value = false;
    zipCodePlaceholder.value = '';
    cityHasError.value = false;
  }

  streetHasError.value = false;

  return !(
    firstNameHasError.value ||
    lastNameHasError.value ||
    companyHasError.value ||
    languageHasError.value ||
    zipHasError.value ||
    cityHasError.value ||
    teamHasError.value
  );
};

const validateCustomerContact = () => {
  customerEmails.value = [...customerEmails.value];
  customerPhones.value = [...customerPhones.value];

  const anyEmailEntered = customerEmails.value.some(
    (e) => e.email && String(e.email).trim() !== ''
  );

  const anyPhoneEntered = customerPhones.value.some(
    (p) => p.phone && String(p.phone).trim() !== ''
  );

  if (!anyEmailEntered && !anyPhoneEntered) {
    if (!customerEmails.value.length) {
      customerEmails.value = [{
        email: '',
        hasError: true,
        errorPlaceholder: t(`addPrivateCostumerModal.${'phoneOrEmailRequired'}`)
      }];
    } else {
      customerEmails.value[0].hasError = true;
      customerEmails.value[0].errorPlaceholder = t(`addPrivateCostumerModal.${'phoneOrEmailRequired'}`);
    }

    if (!customerPhones.value.length) {
      customerPhones.value = [{
        phone: '',
        hasError: true,
        errorPlaceholder: t(`addPrivateCostumerModal.${'phoneOrEmailRequired'}`)
      }];
    } else {
      customerPhones.value[0].hasError = true;
      customerPhones.value[0].errorPlaceholder = t(`addPrivateCostumerModal.${'phoneOrEmailRequired'}`);
    }

    customerEmails.value = [...customerEmails.value];
    customerPhones.value = [...customerPhones.value];

    return false;
  }

  customerEmails.value.forEach((e) => {
    if (e.email && String(e.email).trim() !== '') {
      if (!emailRegex.test(String(e.email).toLowerCase())) {
        e.hasError = true;
        e.errorPlaceholder = t(`addPrivateCostumerModal.${'invalidEmail'}`);
      } else {
        e.hasError = false;
        e.errorPlaceholder = '';
      }
    } else {
      e.hasError = false;
      e.errorPlaceholder = '';
    }
  });

  customerPhones.value.forEach((p) => {
    if (p.phone && String(p.phone).trim() !== '') {
      if (!statics.phoneRegex.test(String(p.phone))) {
        p.hasError = true;
        p.errorPlaceholder = t(`addPrivateCostumerModal.${'invalidPhone'}`);
      } else {
        p.hasError = false;
        p.errorPlaceholder = '';
      }
    } else {
      p.hasError = false;
      p.errorPlaceholder = '';
    }
  });

  customerEmails.value = [...customerEmails.value];
  customerPhones.value = [...customerPhones.value];

  const hasEmailErrors = customerEmails.value.some(e => e.hasError);
  const hasPhoneErrors = customerPhones.value.some(p => p.hasError || p.prefixHasError);

  return !(hasEmailErrors || hasPhoneErrors);
};

const validateEmail = (event, index) => {
  const { value } = event.target;
  customerEmails.value[index].email = value;
  if (customerEmails.value[index].email) {
    if (!emailRegex.test(customerEmails.value[index].email.toLowerCase())) {
      customerEmails.value[index].hasError = true;
      customerEmails.value[index].errorPlaceholder = t(`addPrivateCostumerModal.${'invalidEmail'}`);
    } else {
      customerEmails.value[index].hasError = false;
      customerEmails.value[index].errorPlaceholder = '';
    }
  } else {
    customerEmails.value[index].hasError = false;
    customerEmails.value[index].errorPlaceholder = '';
  }

  const anyEmailEntered = customerEmails.value.some(
    (e) => e.email && String(e.email).trim() !== ''
  );
  if (anyEmailEntered) {
    customerPhones.value.forEach((p) => {
      if (p.errorPlaceholder === t(`addPrivateCostumerModal.${'phoneOrEmailRequired'}`)) {
        p.hasError = false;
        p.errorPlaceholder = '';
      }
    });
    customerPhones.value = [...customerPhones.value];
  }

  customerEmails.value = [...customerEmails.value];
};

const validatePhone = (event, index) => {
  const { value } = event.target;
  customerPhones.value[index].phone = value;
  if (customerPhones.value[index].phone) {
    if (!statics.phoneRegex.test(value)) {
      customerPhones.value[index].hasError = true;
      customerPhones.value[index].errorPlaceholder = t(`addPrivateCostumerModal.${'invalidPhone'}`);
    } else {
      customerPhones.value[index].hasError = false;
      customerPhones.value[index].errorPlaceholder = '';
    }
  } else {
    customerPhones.value[index].hasError = false;
    customerPhones.value[index].errorPlaceholder = '';
  }

  const anyPhoneEntered = customerPhones.value.some(
    (p) => p.phone && String(p.phone).trim() !== ''
  );
  if (anyPhoneEntered) {
    customerEmails.value.forEach((e) => {
      if (e.errorPlaceholder === t(`addPrivateCostumerModal.${'phoneOrEmailRequired'}`)) {
        e.hasError = false;
        e.errorPlaceholder = '';
      }
    });
    customerEmails.value = [...customerEmails.value];
  }

  customerPhones.value = [...customerPhones.value];
};

const addInput = (type) => {
  if (type === 'email') {
    customerEmails.value = [...customerEmails.value, { email: '' }];
  } else if (type === 'phone') {
    customerPhones.value = [
      ...customerPhones.value,
      { phone: '', prefix: '' },
    ];
  }
};

const removeInput = async (type, id, index) => {
  if (type === 'email') {
    if (!id) {
      customerEmails.value.splice(index, 1);
    } else {
      try {
        await store.dispatch('deleteCustomerEmail', id);
        customerEmails.value.splice(
          customerEmails.value.findIndex((email) => email.id === id),
          1
        );
      } catch (err) {
        console.error(err);
      }
    }
  } else if (type === 'phone') {
    if (!id) {
      customerPhones.value.splice(index, 1);
    } else {
      try {
        await store.dispatch('deleteCustomerPhone', id);
        customerPhones.value.splice(
          customerPhones.value.findIndex((phone) => phone.id === id),
          1
        );
      } catch (err) {
        console.error(err);
      }
    }
  }
};

const loadCities = async (value) => {
  await store.dispatch('getZipCodeData', value);
  const currentZip = customerAdresses[0].zip;
  if (String(currentZip) !== String(value)) return;
  if (zipCodeData.value && zipCodeData.value.length) {
    customerAdresses[0].city = zipCodeData.value[0].city;
  } else {
    customerAdresses[0].city = '';
  }
};

const createCustomer = async () => {
  const validDetails = validateCustomerDetails();
  const validContacts = validateCustomerContact();

  if (!validDetails || !validContacts) {
    return;
  }

  await submitCustomer();
};

const submitCustomer = async () => {
  isRequesting.value = true;

  const customer_emails = customerEmails.value?.[0]?.email
    ? customerEmails.value.map(e => ({
        id: e.id,
        email: e.email
      }))
    : [];

  const customer_phones = customerPhones.value?.[0]?.phone
    ? customerPhones.value.map(p => ({
        id: p.id,
        phone: p.phone,
        prefix: p.prefix
      }))
    : [];

  const customerData = {
    member_type_id: customerDetails.type,
    language_id: customerDetails.language,
    team_id: customerDetails.teamId,
    customer_status_id: 2,

    customer_addresses: customerAdresses?.[0]
      ? [customerAdresses[0]]
      : [],

    customer_emails,
    customer_phones
  };

  if (customerDetails.type == 2) {
    customerData.first_name = customerDetails.firstName;
    customerData.last_name = customerDetails.lastName;
  }

  if (customerDetails.type == 1) {
    customerData.company_name = customerDetails.company;
    customerData.company_type_id = 1;
  }

  if (!leadCustomerToEdit.value) {
    customerData.customer_sub_status_id = 1;
  }

  try {
    if (leadCustomerToEdit.value) {
      const customerId = customerEditId.value;

      await store.dispatch('updateLeadCustomer', {
        customerId,
        customerData
      });


      if (route.name === 'AccountDetails') {
        await store.dispatch('getGlobalCustomer', customerId);
        store.commit('setCustomerDetails', customer.value);
      }


      closeModal();
    } else {
      const response = await store.dispatch('createLeadCustomer', customerData);

      closeModal();

      if (response?.data?.data?.id) {
        const customerId = response.data.data.id;

        await router.push({
          name: 'AccountDetails',
          params: {
            entity: 'lead',
            id: customerId
          },
          query: {
            tab: 10
          }
        });
      }
    }
  } catch (err) {
    isRequesting.value = false;

    // Error toast is now handled by the store action
    // Keep field-specific error handling
    if (err.response?.data) {
      let { errors } = err.response.data;

      if (err.response.data.message) {
        errors = err.response.data.errors || err.response.data.message;
      }
      specificErrors.value = parseFieldErrors(errors);
    }
  }
};

// Lifecycle hooks
onMounted(async () => {
  formLoading.value = true;

  const checkPermission = window.$checkRolePermission || (() => true); // Fallback if not available
  if (!(checkPermission('customer_create') || checkPermission('customer_edit'))) {
    closeModal();
  } else {
    const customer_status_id = 2;
    await store.dispatch('getCustomerForms', { customer_status_id });
    if (!leadCustomerToEdit.value && languages.value && languages.value.length) {
      customerDetails.language = languages.value[1].id;
    }

    if (customerForms.value.teams.length > 0) {
      showTeams.value = (loggedUser.value && loggedUser.value.is_super_admin);
    }

    if (leadCustomerToEdit.value) {
      loadFieldsForEdit(leadCustomerToEdit.value);
    }
  }
  formLoading.value = false;
});
</script>

<style scoped>
.customer__form .form .add__content {
    overflow: visible !important;
}
</style>
